module.exports = __webpack_public_path__ + "img/DW_an_Beispielen.50a2862b.svg";